import React from "react";
import clsx from "clsx";
import AGNTHubIcon from "assets/svgComponents/AGNTGubIcon";
import { CheckMarkIcon } from "assets/icons/CheckMarkIcon";
import { ArrowBackIcon } from "assets/icons/ArrowBackIcon";
import { Link } from "react-router-dom";

export const MarketingBanner: React.FC = () => {
  return (
    <div
      className={clsx(
        "flex items-center z-10 justify-center",
        "py-[8px] h-[58px] custom2400:h-[80px]",
        "px-[20px] max-lg:px-[16px]",
        "w-full !rounded-bl-[24px] !rounded-br-[24px]",
        "banner-agnt"
      )}
    >
      <div
        className={clsx(
          "flex items-center gap-[12px] relative z-[20] gap-[10px] sm:gap-[24px]",
          " w-full justify-center "
        )}
      >
        <div className="flex items-center gap-[4px] relative z-[20] max-lg:gap-[2px]">
          <span
            className={clsx(
              "font-luxora-regular text-white",
              "text-[20px] leading-[1.1]",
              "max-lg:text-[16px] custom2400:text-[28px]",
              "whitespace-nowrap relative z-[20]"
            )}
          >
            AGNT
          </span>
          <div className="w-[22px] custom2400:w-[37px] custom2400:h-[37px] bg-white rounded-full flex items-center justify-center h-[22px]">
            <AGNTHubIcon className="w-[22px] h-auto custom2400:w-[37px]" />
          </div>
          <span
            className={clsx(
              "font-luxora-regular text-white",
              "text-[20px] custom2400:text-[28px] leading-[1.1]",
              "max-lg:text-[16px]",
              "whitespace-nowrap"
            )}
          >
            ATTS Token Presale
          </span>
        </div>
        <Link
          target="_blank"
          className={clsx(
            "w-[145px] custom2400:w-[245px]",
            "h-[42px] custom2400:h-[62px] py-[8px] cursor-pointer gap-[10px] sm:gap-[12px]",
            "bg-white rounded-full",
            "flex items-center justify-center",
            "shadow-[0px_2px_4px_0px_rgba(0,0,0,0.05)]"
          )}
          to={"https://token.agnthub.ai/"}
        >
          <div>
            <CheckMarkIcon className="custom2400:w-[26px] h-auto" />
          </div>

          <div className="flex items-center gap-[8px] custom2400:text-[28px]">
            {" "}
            <div>is LIVE!</div>
            <ArrowBackIcon className="custom2400:w-[30px] h-auto" />
          </div>
        </Link>
      </div>
    </div>
  );
};
